module.exports = __webpack_public_path__ + "img/logo-white.6cbbc241.png";